export class VersioneFuturaVO {
    id: string;
    codice: string;
    nome: string;
    dataInizioValidita: string;
    dataFineValidita: string;
}